if (!customElements.get("product-compare-panel")) {
  class ProductComparePanel extends HTMLElement {
    constructor() {
      super(),
        (this.toggle = this.querySelector(".compare-toggle")),
        (this.drawer = this.querySelector(".compare-drawer")),
        (this.clear = this.querySelector(".compare-clear")),
        (this.start = this.querySelector(".compare-start")),
        (this.table = this.querySelector("product-compare-table")),
        (this.max = Number(this.dataset.max)),
        (this.href = ""),
        (this.currentCollection = this.getCurrentCollection());
    }

    connectedCallback() {
      setTimeout(() => this.toggle.classList.add("compare-toggle--active"), 250);
      this.clearOldCollectionData();
      this.addEventListeners();
      this.updateCompareCheckboxes();
      this.updateCompareCounters();
      this.updateStartButton();
    }

    addEventListeners() {
      this.toggle.addEventListener("click", this.onButtonClick.bind(this));
      this.drawer.addEventListener("click", this.onRemoveClick.bind(this));
      this.clear.addEventListener("click", this.onClearClick.bind(this));
      this.start.addEventListener("click", this.onStartClick.bind(this));
      document.addEventListener("change", this.onCheckboxClick.bind(this));
    }

    getCurrentCollection() {
      const path = window.location.pathname;
      const collectionMatch = path.match(/\/collections\/([^\/]+)/);
      return collectionMatch ? collectionMatch[1] : null;
    }

    getStorageKey() {
      return `compare-products-${this.currentCollection}`;
    }

    clearOldCollectionData() {
      const savedCollection = localStorage.getItem('current-compare-collection');
      if (savedCollection && savedCollection !== this.currentCollection) {
        localStorage.removeItem(`compare-products-${savedCollection}`);
        localStorage.removeItem('compare-products'); 
      }
      localStorage.setItem('current-compare-collection', this.currentCollection);
    }

    getSelectedProducts() {
      return JSON.parse(localStorage.getItem(this.getStorageKey())) || [];
    }

    addToCompare(productId, productUrl, productHandle) {
      const compareProducts = this.getSelectedProducts();
      if (!compareProducts.some((product) => product.handle === productHandle)) {
        compareProducts.push({
          id: productId,       // opcional, para debug
          url: productUrl,
          handle: productHandle, // EL QUE USAMOS EN LA URL
          collection: this.currentCollection
        });
        localStorage.setItem(this.getStorageKey(), JSON.stringify(compareProducts));
        this.updateCompareComponents();
      }
    }

    removeFromCompare(productHandle) {
      const compareProducts = this.getSelectedProducts().filter(
        (product) => product.handle !== productHandle
      );
      localStorage.setItem(this.getStorageKey(), JSON.stringify(compareProducts));
      this.updateCompareComponents();
    }

    updateStartButton() {
      const count = this.getCompareCount();
      this.start.disabled = count < 2;
    }

    onCheckboxClick(event) {
      if (event.target.classList.contains("product-card-compare--checkbox")) {
        const { productId, productUrl, productHandle } = event.target.dataset;
        const checkbox = event.target;
        const compareContainer = checkbox.closest('.compare-view-product');

        if (checkbox.checked) {
          if (this.getCompareCount() < this.max) {
            this.addToCompare(productId, productUrl, productHandle);
            compareContainer.classList.add('is-selected');
            this.renderProducts();
            this.openDrawer();
          } else {
            checkbox.checked = false;
          }
        } else {
          this.removeFromCompare(productHandle);
          compareContainer.classList.remove('is-selected');
        }
      }
    }

    updateCompareCheckboxes() {
      const compareProducts = this.getSelectedProducts();
      const compareCount = this.getCompareCount();

      document.querySelectorAll(".product-card-compare--checkbox").forEach((checkbox) => {
        const isChecked = compareProducts.some((product) => product.handle === checkbox.dataset.productHandle);
        const compareContainer = checkbox.closest('.compare-view-product');

        checkbox.checked = isChecked;
        checkbox.disabled = !isChecked && compareCount >= this.max;

        if (isChecked) {
          compareContainer.classList.add('is-selected');
        } else {
          compareContainer.classList.remove('is-selected');
        }
      });
    }

    onRemoveClick(event) {
      if (event.target.classList.contains("compare-remove")) {
        const productHandle = event.target.dataset.productHandle;
        this.removeFromCompare(productHandle);
        event.target.closest("product-card").remove();
      }
    }

    onClearClick() {
      this.getSelectedProducts().forEach((product) => this.removeFromCompare(product.handle));
      this.drawer.querySelector(".compare-drawer--list").innerHTML =
        '<div class="compare-drawer--list-item"></div>'.repeat(this.max);
      this.closeDrawer();
    }

    onStartClick() {
      const count = this.getCompareCount();
      if (count < 2) {
        alert('Selecciona al menos 2 productos para comparar');
        return;
      }

      const compareProducts = this.getSelectedProducts();
      const compareHandles = compareProducts.map(product => product.handle).join(',');

      // Redirigir con handles en la URL
      window.location.href = `/pages/comparar?products=${compareHandles}`;
    }

		openDrawer() {
			OverlayManager.open(this.drawer);
		}

		closeDrawer() {
			OverlayManager.close(this.drawer);
		}

    onButtonClick() {
      this.renderProducts();
      this.openDrawer();
    }

    getCompareCount() {
      return this.getSelectedProducts().length;
    }

    updateCompareCounters() {
      const count = this.getCompareCount();
      document.querySelectorAll(".compare-counter").forEach((counter) => {
        counter.textContent = count;
      });
    }

    async renderProducts() {
      const compareProducts = this.getSelectedProducts();
      const returnHtml =
        (
          await Promise.all(
            compareProducts.map(async (product) => {
              const data = await (await fetch(`${product.url}?sections=product-compare-card`)).json();
              return this.getSectionInnerHTML(data["product-compare-card"], ".shopify-section");
            })
          )
        ).join("") + '<div class="compare-drawer--list-item"></div>'.repeat(this.max - compareProducts.length);

      this.drawer.querySelector(".compare-drawer--list").innerHTML = returnHtml;
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    updateCompareComponents() {
      this.updateCompareCheckboxes();
      this.updateCompareCounters();
      this.updateStartButton();
    }
  }

  customElements.define("product-compare-panel", ProductComparePanel);
}
